import * as React from 'react'
import { FC, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import { ContentCentered } from '@sales-center/components'
import Button from '@mui/material/Button'
import * as styles from './AccessDenied.styles'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '@user/store/authorization'
import { guestRoleName } from '@user/components/Settings/Users/UpdateUser/constants'

export const AccessDeniedPage: FC = () => {
  const navigate = useNavigate()
  const currentUser = useSelector(selectCurrentUser)
  const isGuestUser = currentUser?.roleName === guestRoleName

  const onClickBackButton = useCallback(() => {
    navigate('/scdashboard')
  }, [navigate])

  return (
    <ContentCentered alignItems="center">
      <Box maxWidth={1078} flexGrow={1}>
        <Grid
          container
          spacing={2}
          justifyContent={'center'}
          sx={styles.gridContainerStyles}
        >
          <Grid item xs={10} md={10} lg={5}>
            <Typography mb={0} sx={styles.titleStyles}>
              You do not have access to this page
            </Typography>

            <Typography mb={2.4} sx={styles.subTitleStyles}>
              {isGuestUser
                ? 'As a guest user, you do not have access to this page. ' +
                  'Please contact your administrator for more information.'
                : 'The record may be assigned to a different owner or belong to a  ' +
                  'different sales team. Please contact your administrator for more information.'}
            </Typography>

            <Button variant="contained" onClick={onClickBackButton}>
              Go to {'dashboard'}
            </Button>
          </Grid>

          <Grid item xs={10} md={10} lg={5}>
            <Box sx={styles.imageStyles}>
              <img
                alt={'access-denied landing image'}
                src={'/static-assets/images/access-denied-back.png'}
                style={{ width: '100%' }}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </ContentCentered>
  )
}

AccessDeniedPage.displayName = 'AccessDeniedPage'
